module.exports = __webpack_public_path__ + "static/full-logo-8f869f5f98467e3f0b793b0d0a3ed62e.png";